import React from 'react';
import Immutable from 'immutable';

import { Node } from '@uncinc/react-drupal-core';
import { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import {
  Container,
  SliderRelated,
  useWindowDimensions,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  SCREEN_TABLET, SCREEN_NORMAL, SCREEN_WIDE,
} from '../../../config/constants';

import { NodePartner } from '../../../types/uncinc_profile/nodes';
import './style.scss';

interface ViewPartnersSliderProps {
  entities: Immutable.List<ImmutableEntity<NodePartner>>;
}

const ViewPartnersSlider: React.FC<ViewPartnersSliderProps> = ({ entities }) => {
  const { width } = useWindowDimensions();
  let slidesToShow = 3.5;

  if (width > SCREEN_TABLET) {
    slidesToShow = 4.5;
  }

  if (width > SCREEN_NORMAL) {
    slidesToShow = 8;
  }

  return (
    <div className="ViewPartner">
      <Container medium={width < SCREEN_WIDE}>
        <SliderRelated
          autoplay
          slidesToShow={slidesToShow}
          infinite
          centerMode={false}
          autoplaySpeed="40"
        >
          {
            entities.map((entity) => {
              const id = entity.getIn(['nid', 0, 'value']);
              const uuid = entity.getIn(['uuid', 0, 'value']);
              const langcode = entity.getIn(['langcode', 0, 'value']);
              const key = `${uuid}:${langcode}`;

              return (
                <Node
                  key={key}
                  entity={entity}
                  viewMode="teaser_small"
                />
              );
            })
          }
        </SliderRelated>
      </Container>
    </div>
  );
};

export default ViewPartnersSlider;
